@if (state) {
<i class="fas" [ngClass]="state"></i>
}
